<template>
  <div class="col-6">
    <div class="card m-4">
      <h3 class="card-header text-center">
        {{ $t('first-run.existing-company.heading') }}
      </h3>
      <div class="card-body text-center" style="height:250px">
        <p class="lead" v-html="$t('first-run.existing-company.text')"></p>
        <input v-model="inviteCode" type="text"
               class="mt-5"
               :placeholder="$t('first-run.existing-company.invitecode')"
        >
        <button type="button" class="btn btn-primary btn-md"
                :disabled="verifyPending"
                @click="addToCompany()"
        >
          <span v-if="verifyPending" class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
          ></span>
          {{ $t("first-run.existing-company.verify") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ExistingCompany',
    data: function() {
        return {
            inviteCode: '',
            verifyPending: false,
        }
    },
    methods: {
        addToCompany() {
            this.verifyPending = true
            this.$store.dispatch('verifyInviteCode', this.inviteCode)
                .then(async result => {
                    const userId = await this.$store.dispatch('getUserId')
                    const data = {
                        user: { id: userId },
                        company: { id: _.head(result).id },
                        method: 'get',
                    }
                    this.$store.dispatch('addAclToCompany', data)
                        .then(res => {
                            this.verifyPending = false
                            this.$store.dispatch('currentUserCheck')
                            this.flash(`Byl jste přiřazen do firmy`, 'success', {
                                timeout: 3000,
                            })
                            this.$router.push('/dashboard')
                        })
                })
        },
    },
}
</script>
